export default __webpack_public_path__ + "static/black-mobile-logo-c74695520e362d809ccb27ab6b866087.svg";